import * as React from 'react';
import { UnifiedPayee } from '@mortee/domain/morteeAccountVerificationUnifiedPayee';
import BasePayeeSearchInput from './BasePayeeSearchInput';

interface PayeeSearchInputProps {
  onPayeeSelected: (payee: UnifiedPayee) => void;
  value?: string;
  onValueChange?: (value: string) => void;
  onManualEditAfterSelection?: () => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  disabled?: boolean;
}

const PayeeSearchInput = React.forwardRef<HTMLInputElement, PayeeSearchInputProps>(
  (
    {
      onPayeeSelected,
      value,
      onValueChange,
      onManualEditAfterSelection,
      placeholder = 'Type or search a payee',
      className,
      inputClassName,
      disabled,
    },
    ref,
  ) => {
    const getDisplayValue = (payee: UnifiedPayee): string => {
      return payee.names?.[0]?.name || '';
    };

    return (
      <BasePayeeSearchInput
        ref={ref}
        id='payee-search-input'
        onPayeeSelected={onPayeeSelected}
        value={value}
        onValueChange={onValueChange}
        onManualEditAfterSelection={onManualEditAfterSelection}
        placeholder={placeholder}
        className={className}
        inputClassName={inputClassName}
        getDisplayValueForSelectedPayee={getDisplayValue}
        disabled={disabled}
      />
    );
  },
);

PayeeSearchInput.displayName = 'PayeeSearchInput';

export default PayeeSearchInput;
